import React, { useState, useRef } from 'react'
import axios from 'axios'
import isEqual from 'lodash.isequal'
import { Container, CircularProgress } from '@material-ui/core'
import FeedbackFactory from 'components/FeedbackFactory/FeedbackFactory'
import TechlinkItemIndex from './TechlinkItemIndex/TechlinkItemIndex'
import TechlinkItemOffers from 'iframe/techlink/TechlinkItemOffers/TechlinkItemOffers'
import RouteMap from 'assets/RouteMap.js'
import TechlinkCompanyFilters from './TechlinkCompanyFilters/TechlinkCompanyFilters'
import TechlinkNavbar from '../TechlinkNavbar/TechlinkNavbar'
import URLParamsHandler from 'assets/URLParamsHandler.js'
import { SAVE_FILTERS } from 'assets/AuthentificationHelper'
import FiltersHelper from 'assets/FiltersHelper'

const TechlinkCompanyIndex = (props) => {
    const mapRef = useRef(null)
    const feedbackRef = useRef(null)
    const type = 'company'

    const [state, setState] = useState({
        applyJob: false,
        cardRef: useRef(),
        currentPage: URLParamsHandler.loadCurrentPage(),
        filters: null,
        indexRef: useRef(),
        isCheckMap: true,
        itemDivSelected: '',
        itemSelected: '',
        items: [],
        itemsGeocoding: false,
        jumpingRef: useRef(),
        listRef: useRef(),
        loadMoreStatus: true,
        loadPreviousPage: URLParamsHandler.loadPreviousPageBool(),
        loading: true,
        loadingMore: false,
        needRedirect: false,
        offerCount: '0',
        redirect_to: '',
        showAlertModalOnPageLoad: props.user?.type === 'student' && URLParamsHandler.loadProcessFromURL() === SAVE_FILTERS,
        showAlertModalOnPageLoadOrigin: URLParamsHandler.parseURLParams().alertOrigin,
        showRef: useRef()
    })

    const urlFilters = URLParamsHandler.loadUrlFilters(type)

    const setFilters = (filters) => {
        setState((prevState) => ({ ...prevState, filters }))
    }

    const setCheckMap = (checked) => {
        setState((prevState) => ({ ...prevState, isCheckMap: checked }))
    }

    const getCoords = (filterCities) => {
        if (filterCities && filterCities.length) {
            return filterCities.map((option) => {
                return {
                    long: option.long,
                    lat: option.lat,
                    value: option.value
                }
            })
        } else {
            return 'null'
        }
    }

    const filterItems = (tmpFilters) => {
        const loadingMore = !tmpFilters
        const filters = tmpFilters || state.filters

        const currentPage =
            loadingMore && !state.loadPreviousPage
                ? state.currentPage + 1
                : state.loadPreviousPage
                    ? state.currentPage
                    : 1

        setState((prevState) => ({
            ...prevState,
            filters,
            currentPage,
            loadingMore,
            loading: !loadingMore
        }))

        const params = {
            locale: RouteMap.GetLocaleFromUrl(),
            title: filters.title,
            study_domain: FiltersHelper.getValues(filters.studyDomain),
            location: getCoords(filters.location),
            company_size: FiltersHelper.getValues(filters.companySize),
            job_type: FiltersHelper.getValues(filters.jobType),
            sector: FiltersHelper.getValues(filters.sector),
            quick_filter: 'techlink',
            page: currentPage // TODO: Fixing Edouard changes by putting seemore in AlertCTA, filter would reload the same filter the first 2 time
        }

        axios.get('/api/v1/companies/filter', { params })
            .then((response) => {
                let loadMoreStatus = true

                if (type === 'company' && response.data.res) {
                    if (response.data.res.length < 18) {
                        loadMoreStatus = false
                    }
                } else {
                    if (response.data.res.length < 27) {
                        loadMoreStatus = false
                    }
                }

                if (response.data.search_count === response.data.res.length) {
                    loadMoreStatus = false
                }

                let items = loadingMore ? state.items : []
                items = items.concat(response.data.res)

                if (response.data.search_count === items.length) {
                    loadMoreStatus = false
                }

                setState((prevState) => ({
                    ...prevState,
                    loadMoreStatus,
                    items,
                    itemsGeocoding: response.data.items_geocoded,
                    offerCount: response.data.search_count,
                    loading: false,
                    loadingMore: false
                }))

                window.prerenderReady = true

                if (state.loadPreviousPage) {
                    setState((prevState) => ({
                        ...prevState,
                        currentPage
                    }))
                }

                URLParamsHandler.createURLFilters(type, filters, currentPage)
            })
            .catch((error) => {
                console.error(error)
            })
    }

    return (
        <>
            <TechlinkNavbar type='company'/>
            <FeedbackFactory ref={feedbackRef} />
            <TechlinkCompanyFilters
                key="searchbar"
                type={type}
                selectedLocationTag={props.selectedLocationTag}
                user={props.user}
                handleFilterChange={filterItems}
                filters={state.filters || {}}
                setFilters={setFilters}
                location={props.selectedLocationTag}
                urlFilters={urlFilters}
                offerCount={state.offerCount}
                techlink
            />
            <Container maxWidth="lg">
                {!state.loading && (
                    <TechlinkItemOffers
                        offerCount={state.offerCount}
                        totalCount={props.totalCount}
                        cardRef={state.cardRef}
                        listRef={state.listRef}
                        user={props.user}
                        type={type}
                        setCheckMap={setCheckMap}
                        isCheckMap={state.isCheckMap}
                        selectedLocationTag={props.selectedLocationTag}
                    />
                )}
                {state.loading && (
                    <div className='loading-cirular'>
                        <CircularProgress
                            color='primary'
                            style={{ width: '80px', height: '80px' }}
                        />
                    </div>
                )}
                <TechlinkItemIndex
                    type={type}
                    currentTab={props.currentTab}
                    items={state.items}
                    itemsGeocoding={state.itemsGeocoding}
                    cardSlider={props.cardSlider}
                    cardRef={state.cardRef}
                    listRef={state.listRef}
                    mapRef={mapRef}
                    userAddress={props.userAddress}
                    user={props.user}
                    userType={props.user && props.user.type}
                    currentPage={state.currentPage}
                    offerCount={state.offerCount}
                    filters={state.filters}
                    loadMoreStatus={state.loadMoreStatus}
                    pageName={props.pageName}
                    ads={props.ads}
                    selectedArticletag={props.selectedArticleTag}
                    jumpingRef={state.jumpingRef}
                    lang={props.lang}
                    loading={state.loading}
                    loadingMore={state.loadingMore}
                    filterItems={filterItems}
                    selectedLocationTag={props.selectedLocationTag}
                />
            </Container>
        </>
    )
}

export default TechlinkCompanyIndex
